// extracted by mini-css-extract-plugin
export default {"container":"TrendingAreaCard_container__3hPF-","image":"TrendingAreaCard_image__HJRmf","title":"TrendingAreaCard_title__TROgF"};